import React from 'react';

function CourseShowcase() {
    return (
        <div className="page-container">
            <h1>Course Showcase & Success Stories</h1>
            <p>See what our learners have achieved and explore examples of our engaging workshops.</p>
            <div className="image-scroll-container">
                <img src="https://source.unsplash.com/random/600x400/?adult,learning,classroom" alt="Workshop in action" className="image" />
                <img src="https://source.unsplash.com/random/600x400/?students,studying,group" alt="Learner collaboration" className="image" />
                <img src="https://source.unsplash.com/random/600x400/?graduation,adult,education" alt="Successful graduate" className="image" />
                <img src="https://source.unsplash.com/random/600x400/?online,course,laptop" alt="Online learning setup" className="image" />
            </div>
            <p style={{ marginTop: "2rem" }}>Our courses are designed to be practical, engaging, and immediately applicable. We focus on building real-world skills and fostering a love for lifelong learning. Many of our participants have gone on to achieve new career heights, start businesses, or simply gain more confidence in their daily lives.</p>
        </div>
    );
}

export default CourseShowcase;